import React from 'react'
import styled, { keyframes } from 'styled-components'

interface SkeletonProps {
  width: number | string
  height: number | string
  maxWidth?: number | string
  borderRadius?: number
}

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`

const SkeletonContainer = styled.div<Required<SkeletonProps>>`
  position: relative;
  overflow: hidden;
  background-color: #e1e1e1;
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height)};
  max-width: ${({ maxWidth }) => (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth)};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
`

const Shimmer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 200%;
  background: linear-gradient(to right, #e1e1e1 0%, #f5f5f5 50%, #e1e1e1 100%);
  animation: ${shimmer} 1.2s linear infinite;
`

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  maxWidth = '100%',
  borderRadius = 0,
}) => {
  return (
    <SkeletonContainer
      width={width}
      height={height}
      maxWidth={maxWidth}
      borderRadius={borderRadius}
    >
      <Shimmer />
    </SkeletonContainer>
  )
}

export default Skeleton
